import type { PricePoint, PricedPricing } from "~/lib/api";
import { Button } from "~/components/ui/button";
import { Icon } from "~/components/ui/icons/icon";
import { PricePointEditor } from "./PricePointEditor";
import { formatPricePointLabel } from "./pricing-types";

export function PricePointList({
  pricing,
  canEdit,
  onChange,
  onRemove,
}: {
  pricing: PricedPricing;
  canEdit?: boolean;
  onChange: (index: number, updated: PricePoint) => void;
  onRemove: (index: number) => void;
}) {
  return (
    <div className="space-y-1">
      {pricing.prices.map((price, i) => (
        <div key={`${price.type}-${price.label ?? ""}`} className="flex items-center gap-2">
          <PricePointEditor
            value={price}
            currency={pricing.currency}
            onChange={(updated) => onChange(i, updated)}
            canEdit={canEdit}
          />
          {canEdit && (
            <Button
              variant="ghost"
              size="icon-sm"
              onClick={() => onRemove(i)}
              aria-label={`Remove ${formatPricePointLabel(price)}`}
            >
              <Icon i="close" className="size-4 text-muted-foreground" />
            </Button>
          )}
        </div>
      ))}
    </div>
  );
}
